var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48576",
    "data-name": "Group 48576",
    transform: "translate(-916 -695)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138030",
    "data-name": "Rectangle 138030",
    width: 24,
    height: 24,
    transform: "translate(916 695)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48574",
    "data-name": "Group 48574",
    transform: "translate(-21 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93205",
    "data-name": "Path 93205",
    d: "M17.93,20.75c0-3.87-3.85-7-8.59-7s-8.59,3.13-8.59,7",
    transform: "translate(940.25 680.25)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_423",
    "data-name": "Ellipse 423",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(944.59 681)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.1644d3290104e9b6c8b34e73c8fec348.svg";
export { ForwardRef as ReactComponent };